import { useEffect } from "react";
import { canalDistController, CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../canalDist.controll";
import { CanalDistribuicao } from "../canalDist.model";
import { Select as ViewList } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import Modal from "../../../components/modal";
import { connect } from "react-redux";
import { formatData, getDataText } from "../../../services/utils";
import store from "../../../store";

const columns: GridColDef[] = [
    { field: 'data', headerName: 'Data Abertura', flex: 3, valueFormatter: (value, row) => formatData(value) },
    { field: 'funcionario.nome', headerName: 'Funcionario', flex: 4, valueFormatter: (value, row) => row.funcionario.nome },
    { field: 'situacao', headerName: 'Situação', flex: 3 },
]


interface SelecionarCanalDistribuicaoProps extends CanalDistribuicaoViewProps {
    handleConfirmar: (canalDist: CanalDistribuicao) => any;
    filtroData: string
}

function SelecionarCanalDistribuicao(props: SelecionarCanalDistribuicaoProps) {
    const { canalDistribuicaoActions, canalDistribuicaoState, handleConfirmar } = props
    const { error, loadingRows, msg, row, rowsSelected, showAlert, status, showCadModal, changeList, showSelectModal } = canalDistribuicaoState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = canalDistribuicaoActions

    useEffect(() => {
        console.log("chamou Selecionar CanalDistribuicao")
        readCanalAberto()
    }, [])

    const readCanalAberto = () => {
        /*if (props.filtroData) {
            let dtIni = new Date(props.filtroData);
            dtIni.setHours(0,0);
            let dtFim = new Date(props.filtroData);
            dtFim.setHours(23,59);
            canalDistribuicaoActions.read({
                fieldsFilter: [
                    { fieldName: "data", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]                    
                    }
                ],
                indexName: "idx_canal_dist_filtro_data"
            });

        } else {
            canalDistribuicaoActions.read({
                fieldsFilter: [
                    { fieldName: "situacao", mangoQuery: "$eq", fieldValue: "ABERTO" },
                ],
                indexName: "idx_canal_dist_aberto"
            });

        }
        
         */
        canalDistribuicaoActions.readCanalDistByDia(props.filtroData)
    }



    const handleSelecionar = (canalDist: CanalDistribuicao) => {
        handleConfirmar(canalDist);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Canal de Distribuição"}
                    subtitle={`Exibindo canais do dia: ${getDataText(props.filtroData)}`}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: CanalDistribuicao) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    fieldSearch={"funcionario.nome"}
                    columns={columns}
                    rows={rowsSelected}
                    loading={loadingRows}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: false,
                        onClick: () => { }
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => readCanalAberto()
                    }}
                    ListItemTextPrimary={(row: CanalDistribuicao) => <Typography component={"span"}>{row.funcionario.nome}</Typography>}
                    ListItemTextSecondary={(row: CanalDistribuicao) =>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography component={"span"}>{formatData(row.data)} {row.situacao}</Typography>
                        </Box>
                    }
                />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="sm"
            handleOnKeyDown={() => { }}
        />
    )
}

export default connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(SelecionarCanalDistribuicao);

export const handleShowSelecionarCanalDist = (set: boolean) => {
    store.dispatch(canalDistController.reducer.actions.setShowSelectModal(set))
}